import { apiClient } from "../../lib/http/apiClient";
import type {
  CommunityListResponse,
  CommunityComment,
  CommunityPost,
  MandatoryPendingResponse,
} from "./types";

// User-facing community API. The shared apiClient auto-attaches the logged-in
// user's JWT, so no explicit headers are needed here.
export const communityService = {
  async listPosts(params: Record<string, unknown> = {}): Promise<CommunityListResponse> {
    const { data } = await apiClient.get<CommunityListResponse>("/api/community/posts", { params });
    return data;
  },

  async getPost(postId: string): Promise<CommunityPost> {
    const { data } = await apiClient.get<CommunityPost>(`/api/community/posts/${postId}`);
    return data;
  },

  async vote(postId: string, optionIndex: number): Promise<CommunityPost> {
    const { data } = await apiClient.post<CommunityPost>(
      `/api/community/posts/${postId}/vote/${optionIndex}`,
    );
    return data;
  },

  async answer(postId: string, body: string): Promise<CommunityComment> {
    const { data } = await apiClient.post<CommunityComment>(
      `/api/community/posts/${postId}/answer`,
      { body },
    );
    return data;
  },

  async acknowledge(postId: string): Promise<CommunityPost> {
    const { data } = await apiClient.post<CommunityPost>(
      `/api/community/posts/${postId}/acknowledge`,
    );
    return data;
  },

  async listComments(postId: string): Promise<CommunityComment[]> {
    const { data } = await apiClient.get<CommunityComment[]>(
      `/api/community/posts/${postId}/comments`,
    );
    return data;
  },

  async toggleLike(postId: string): Promise<{ liked: boolean; like_count: number }> {
    const { data } = await apiClient.post<{ liked: boolean; like_count: number }>(
      `/api/community/posts/${postId}/like`,
    );
    return data;
  },

  async mandatoryPending(): Promise<MandatoryPendingResponse> {
    const { data } = await apiClient.get<MandatoryPendingResponse>(
      "/api/community/mandatory/pending",
    );
    return data;
  },
};
